import { useQuery } from "@tanstack/react-query";
import { Button, Checkbox, Collapse, Spin } from "antd";
import { FC, useEffect, useState } from "react";
import { selectedService, service } from "../../../types/service";
import {
  lightPointSVG,
  primaryPackageSVG,
  servicesRollSVG,
} from "../../../assets/SVGs/SVGs";
import { useDispatch, useSelector } from "react-redux";
import {
  setLocationData,
  setPackages,
  setServices,
} from "../../../services/store/slices/cart";
import { useParams, useSearchParams } from "react-router-dom";
import { salonLocationBySlug } from "../../../network/clientSide";
import { selectedPackages } from "../../../types/package";
import { useIntl } from "react-intl";

interface ServicesProps {}
type category = {
  id: number;
  name: string;
  title: string;
  services: service[];
};
type serviceType = {
  id: number;
  name: string;
  service_category_id: number;
  pricing_options: {
    id: number;
    price: string;
    duration: string;
  }[];
  service_category: category;
};
const Services: FC<ServicesProps> = ({}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const params = useParams();
  const { salonSlug } = params;
  const [searchParams, setSearchParams] = useSearchParams();
  const isAllCatalog = searchParams.get("catalog") === "all";
  const { data: salonDetails, isLoading } = useQuery(
    ["salonDetails-services", salonSlug],
    () =>
      salonLocationBySlug(salonSlug, {
        link_type: isAllCatalog ? "catalog_link" : "service_link",
      }),
    {
      enabled: !!salonSlug,
      select: (res) => res?.data?.data?.location,
    }
  );
  if (salonDetails?.id) {
    dispatch(setLocationData({ id: salonDetails?.id }));
  }

  const [selectedCategory, setSelectedCategory] = useState<category | null>(
    null
  );
  const [categories, setCategories] = useState<category[]>([]);
  const { services, packages } = useSelector(
    (state: {
      cart: {
        services: { services: selectedService[]; packages: selectedPackages[] };
      };
    }) => state.cart.services
  );
  useEffect(() => {
    if (salonDetails) {
      const newCategories: category[] = [];
      salonDetails[isAllCatalog ? "services" : "link_services"]?.map(
        (s: serviceType) => {
          if (!newCategories.find((c) => c.id === s?.service_category_id)) {
            newCategories.push(s?.service_category);
          }
        }
      );
      setCategories(newCategories);
      if (newCategories?.length) {
        setSelectedCategory(newCategories[0]);
      }
      if (salonDetails && services?.length) {
        services?.map((service) => {
          let flag = true;
          salonDetails?.link_services?.map(
            (parentService: {
              id: number;
              name: string;
              service_category_id: number;
              pricing_options: {
                id: number;
                price: string;
                duration: string;
              }[];
            }) => {
              parentService?.pricing_options?.map((option) => {
                if (service?.id === option?.id) {
                  flag = false;
                }
              });
            }
          );
          if (flag) {
            dispatch(setServices([]));
          }
        });
      }
    }
  }, [isLoading]);
  if (isLoading) {
    return (
      <div className=" flex absolute justify-center items-center">
        <Spin size="large" />
      </div>
    );
  }
  const formatPackagesWithCategories = () => {
    let packagesWithCategories: any[] = [];
    if (salonDetails?.link_packages?.length || salonDetails?.packages?.length) {
      salonDetails[isAllCatalog ? "packages" : "link_packages"]?.map(
        (pkg: {
          id: number;
          name: string;
          retail_price: string;
          package_category: {
            id: number;
            name: string;
          };
          pricing_option: {
            id: number;
            name: string;
            duration: string;
            price: string;
            service: { id: number; name: string };
          }[];
        }) => {
          const exitedCategoryIndex = packagesWithCategories?.findIndex(
            (category) => category?.id === pkg?.package_category?.id
          );

          if (exitedCategoryIndex < 0) {
            packagesWithCategories.push({
              id: pkg?.package_category?.id,
              name: pkg?.package_category?.name,
              packages: [
                {
                  ...pkg,
                  retail_price: pkg.retail_price,
                },
              ],
            });
          } else {
            packagesWithCategories[exitedCategoryIndex]?.packages.push({
              ...pkg,
              retail_price: pkg.retail_price,
            });
          }
        }
      );
    }
    return packagesWithCategories;
  };

  formatPackagesWithCategories();
  return (
    <div className="shadow p-6 space-y-4 rounded-lg  max-h-[100vh] ">
      <div className="space-y-4">
        <h4 className="text-salon-primary text-xl ">
          {intl.formatMessage({ id: "chooseServiceOrPackage" })}{" "}
        </h4>
        <p className="text-color-sec-title">
          {intl.formatMessage({ id: "chooseServiceOrPackageDesc" })}
        </p>
      </div>
      <div className="p-4 bg-[#EEF0FF] flex gap-3  overflow-auto rounded ">
        <Button
          key={-20}
          type={-20 === selectedCategory?.id ? "primary" : "default"}
          onClick={() =>
            setSelectedCategory({
              id: -20,
              name: intl.formatMessage({ id: "packages" }),
              title: "",
              services: [],
            })
          }
        >
          {intl.formatMessage({ id: "packages" })}
        </Button>
        {categories?.map((category: category) => (
          <Button
            key={category.id}
            type={category.id === selectedCategory?.id ? "primary" : "default"}
            onClick={() => setSelectedCategory(category)}
          >
            {category?.name}
          </Button>
        ))}
      </div>
      <div>
        <p className="text-salon-primary  ">{selectedCategory?.name}</p>
      </div>
      <div className="checkbox-full-width max-h-[60vh] overflow-auto">
        {selectedCategory !== null ? (
          <>
            {selectedCategory?.id !== -20 ? (
              salonDetails[isAllCatalog ? "services" : "link_services"]?.map(
                (service: serviceType) =>
                  service?.service_category_id === selectedCategory?.id &&
                  service?.pricing_options?.map((option) => (
                    <Checkbox
                      checked={
                        !!services?.find((item) => item.id === option?.id)
                      }
                      onChange={(e) => {
                        if (e.target.checked) {
                          const newServices = [
                            ...services,
                            {
                              id: option?.id,
                              name: service?.name,
                              price: option?.price,
                              duration: option?.duration,
                              service_id: service?.id,
                            },
                          ];
                          dispatch(setServices(newServices));
                        } else {
                          const filteredServices = services.filter(
                            (item) => item.id !== option?.id
                          );
                          dispatch(setServices(filteredServices));
                        }
                      }}
                      key={option?.id}
                      className="w-full bg-[#FBFBFF] "
                    >
                      <div
                        className="w-full flex justify-between p-1 gap-2 items-center h-10 text-sm bg-white rounded   my-1  "
                        key={option?.id}
                      >
                        <div className="flex gap-2">
                          <p className="">{servicesRollSVG}</p>
                          <p className="capitalize">{service?.name}</p>
                        </div>
                        <p className="self-start">{lightPointSVG}</p>
                        <p>
                          {option?.duration}
                          <span className="mx-1 text-xs text-gray-500">
                            {intl.formatMessage({ id: "mins" })}{" "}
                          </span>
                        </p>
                        <p className="self-start">{lightPointSVG}</p>
                        <p>
                          {option?.price}

                          <span className="mx-1 text-xs text-gray-500">
                            {intl.formatMessage({ id: "SAR" })}{" "}
                          </span>
                        </p>
                      </div>
                    </Checkbox>
                  ))
              )
            ) : (
              <div className="space-y-3">
                {formatPackagesWithCategories()?.map(
                  (category: {
                    id: number;
                    name: string;
                    packages: selectedPackages[];
                  }) => (
                    <div className="space-y-2" key={category?.id}>
                      <p>{category?.name}</p>
                      {category?.packages?.map((pkg) => (
                        <div className="flex gap-1">
                          <Checkbox
                            checked={
                              !!packages?.find((item) => item.id === pkg?.id)
                            }
                            onChange={(e) => {
                              if (e.target.checked) {
                                const newPackages: selectedPackages[] = [
                                  ...packages,
                                  {
                                    id: pkg?.id,
                                    name: pkg?.name,
                                    retail_price: pkg?.retail_price,
                                    total_time: pkg?.total_time,
                                    pricing_option: pkg?.pricing_option,
                                  },
                                ];
                                dispatch(setPackages(newPackages));
                              } else {
                                const filteredServices = packages.filter(
                                  (item) => item.id !== pkg?.id
                                );
                                dispatch(setPackages(filteredServices));
                              }
                            }}
                            key={pkg?.id}
                            className=" bg-[#FBFBFF] "
                          ></Checkbox>
                          <Collapse
                            className="w-full bg-white border-none"
                            items={[
                              {
                                label: (
                                  <div
                                    className="w-full   flex justify-between  gap-2  text-sm bg-white rounded   my-1  "
                                    key={pkg?.id}
                                  >
                                    <div className="flex gap-2">
                                      <p>{primaryPackageSVG}</p>
                                      <p className="capitalize">{pkg?.name}</p>
                                    </div>
                                    <p>
                                      {pkg?.pricing_option?.length}
                                      <span className="mx-1 text-xs text-gray-500">
                                        {intl.formatMessage({ id: "services" })}
                                      </span>
                                    </p>
                                    <p>
                                      {pkg?.total_time}
                                      <span className="mx-1 text-xs text-gray-500">
                                        {intl.formatMessage({ id: "mins" })}
                                      </span>
                                    </p>
                                    <p>
                                      {pkg?.retail_price}

                                      <span className="mx-1 text-xs text-gray-500">
                                        {intl.formatMessage({ id: "SAR" })}
                                      </span>
                                    </p>
                                  </div>
                                ),
                                children: (
                                  <div className="">
                                    {pkg?.pricing_option?.map((option) => (
                                      <div
                                        key={option?.id}
                                        className="flex justify-between gap-2"
                                      >
                                        <div className="flex gap-2 items-center">
                                          <p>
                                            {
                                              <p className="">
                                                {servicesRollSVG}
                                              </p>
                                            }
                                          </p>
                                          <p className="capitalize">
                                            {option?.service?.name}
                                          </p>
                                        </div>
                                        <div className="flex gap-1 text-salon-primary ">
                                          <p>{option?.duration}</p>
                                          <small className="text-xs self-end">
                                            {intl.formatMessage({ id: "mins" })}
                                          </small>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                ),
                              },
                            ]}
                          />
                        </div>
                      ))}
                    </div>
                  )
                )}
              </div>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Services;
